$(function() {
	const $doc = $(document);

	// モーダルを閉じる処理
	$doc.on('click', '.modal_wrapper .close_modal, .modal_wrapper .overlay', closeModal);
	$doc.on('click', '.modal_wrapper .age_confirmation_submit', onClickAgeConfirmationSubmit);

	// モーダルを表示させる系
	$doc.on('click', '.designated_second_class_drug_banner', onClickDesignatedSecondClassDrugBanner); // 指定第二類医薬品
	$doc.on('click', '.age_confirmation_btn', onClickAgeConfirmationBtn); // 年齢認証
	$doc.on('click', '.membership_cancel_request_link', onClickMembershipCancelRequestLink);

	// アンカーリンククリック時のスムーススクロール
	$doc.on('click', '.smooth_scroll', onClickSmoothScroll);

	// カテゴリ一覧リスト系
	$doc.on('click', '#sidebarCategoryList .category_large', onClickSidebarCategoryLarge);
	$doc.on('click', '#menu-drawer .link_product_list a', onClickMenuDrawerLinkProductList);
	$doc.on('click', '#menu-drawer .menu_drawer_title', onClickMenuDrawerTitle);
	$doc.on('click', '#menu-drawer .drawer_category_list .category_large', onClickMenuDrawerCategoryLarge);

	// フッターまわり
	$doc.on('click', '.show_additional_cost_explanation_area_btn', onClickShowAdditionalCostExplanationAreaBtn);
	$doc.on('click', '.show_certificate_of_approval_area_btn', onClickShowCertificateOfApprovalAreaBtn);
	$doc.on('click', '.show_relief_system_area_btn', onClickShowReliefSystemAreaBtn);

	// 入力上限や下限があるフォームパーツの制御
	$doc.on('change', 'input[max]', validateValueMax);
	$doc.on('blur', 'input[max]', validateValueMax);

	// スクロール発火系のイベント
	$(window).on('scroll', function() {
		// ページTOPへのスクロールボタンをスクロール位置に応じて表示・非表示
		const scroll = $(this).scrollTop();
		if (scroll > 700) {
			$('#scrollToTopBtn').removeClass('hidden');
		} else {
			$('#scrollToTopBtn').addClass('hidden');
		}
	});

	initCommon();
})

/**
 * 共通の初期化処理
 */
function initCommon() {
	initFancybox();
	initCalendarBox();
}

/**
 * fancybox初期化処理
 */
function initFancybox() {
	Fancybox.bind("[data-fancybox]", {
		// Your custom options
	});
}

/**
 * Googleカレンダー初期化
 * 当月のカレンダーiframeのsrcを元に翌月用のカレンダーiframeにsrcを設定します
 */
function initCalendarBox() {
	// カレンダーの表示サイズを矯正
	$('.calendar_box').find('iframe').removeAttr('width').css({width: '100%'});

	// 元になっているiframeのsrc属性を取得(当月を表示させるカレンダー)
	const iframeSrc = $('.calendar_box.this_month').find('iframe').attr('src');
	$('.calendar_box.next_month').find('iframe').attr('src', iframeSrc + `&dates=${getNextMonthFirstDay()}/${getNextMonthLastDay()}`);
}

/**
 * サイドバー内カテゴリアコーディオンの「カテゴリ大」クリック時処理
 * @param e
 */
function onClickSidebarCategoryLarge(e) {
	e.preventDefault();

	if ($(this).hasClass('is_open')) {
		$(this).removeClass('is_open');
		$(this).parent().find('.category_medium_list').slideUp(200);
	} else {
		$(this).addClass('is_open');
		$(this).parent().find('.category_medium_list').slideDown(200);
	}
}

/**
 * ドロワーメニュー内の「商品一覧」リンククリック時処理
 * @param e
 */
function onClickMenuDrawerLinkProductList(e) {
	e.preventDefault();

	$('ul.menu-drawer__menu').hide();
	$('#drawerCategoryList').show();

	$menuDrawerTitle = $('#menu-drawer .menu_drawer_title');
	$menuDrawerTitle.addClass('back_to_main_nav');
	$menuDrawerTitle.removeClass('back_to_category_list');
}


/**
 * ドロワーメニュー見出しクリック時処理
 * @param e
 */
function onClickMenuDrawerTitle(e) {
	if ($(this).hasClass('back_to_main_nav')) {
		$(this).text('商品一覧');

		$('ul.menu-drawer__menu').show();
		$('#drawerCategoryList').hide();
	} else if ($(this).hasClass('back_to_category_list')) {
		$(this).text('商品一覧');

		// 大カテゴリ一覧に戻る場合は、中カテゴリ一覧をempty()してカテゴリ一覧を表示
		$(this).removeClass('back_to_category_list');
		$(this).addClass('back_to_main_nav');
		$('.drawer_category_link_list').empty();
		$('.drawer_category_list').show();
	} else {
		$(this).addClass('back_to_main_nav');

		$('ul.menu-drawer__menu').hide();
		$('#drawerCategoryList').show();
	}
}

/**
 * ドロワーメニュー内　大カテゴリクリック時処理
 * @param e
 */
function onClickMenuDrawerCategoryLarge(e) {
	e.preventDefault();
	const $drawerCategoryLinkList = $('.drawer_category_link_list');
	// 初期化
	$drawerCategoryLinkList.empty();

 	// ドロワー見出しの調整
	const $menuDrawerTitle = $('#menu-drawer .menu_drawer_title');
	$menuDrawerTitle.removeClass('back_to_main_nav');
	$menuDrawerTitle.addClass('back_to_category_list');
	$menuDrawerTitle.text($(this).text());

	// カテゴリ大リストを非表示
	$('.drawer_category_list').hide();
	// カテゴリ中リストを表示
	const drawerCategoryLinkListInnerHtml = $(this).parent().find('.category_medium_list').html();
	$drawerCategoryLinkList.html(drawerCategoryLinkListInnerHtml);
}


/**
 * 指定第二類医薬品バナークリック時処理
 */
function onClickDesignatedSecondClassDrugBanner(e) {
	e.preventDefault();

	$('#modalDesignatedSecondClassDrug').fadeIn(MODAL_FADE_DURATION);
}

/**
 * モーダルを閉じる
 */
function closeModal(e) {
	e.preventDefault();

	$(this).parents('.modal_wrapper').fadeOut(MODAL_FADE_DURATION);
}

/**
 * 年齢認証ボタンクリック時処理
 * @param e
 */
function onClickAgeConfirmationBtn(e) {
	e.preventDefault();
	$('#modalAgeConfirmation').fadeIn(MODAL_FADE_DURATION);
}

/**
 * 年連認証モーダル内の「はい」ボタンクリック時処理
 * @param e
 */
function onClickAgeConfirmationSubmit(e) {
	e.preventDefault();

	$('.age_confirmation_btn_box').remove();
	$('.only_20_over').removeClass('only_20_over');
	$('#modalAgeConfirmation').fadeOut(MODAL_FADE_DURATION);
}

/**
 * 退会申請リンククリック時処理
 * @param e
 */
function onClickMembershipCancelRequestLink(e) {
	e.preventDefault();

	$('#modalMemberShipCancelRequest').fadeIn(MODAL_FADE_DURATION);
}

/**
 * スムーススクロール要素をクリックした時の処理
 */
function onClickSmoothScroll(e) {
	e.preventDefault();
	// const headerHeight = $('.section-header').innerHeight();
	const headerHeight = 20;
	let targetId = $(this).attr('href');
	let targetPos = $(targetId).offset().top;
	let speed = 300;
	$('html, body').animate({
		scrollTop: targetPos - headerHeight
	}, speed);
}

/**
 * 「お支払方法・送料・手数料に関する説明エリアを表示」ボタンクリック時処理
 * @param e
 */
function onClickShowAdditionalCostExplanationAreaBtn(e) {
	e.preventDefault();

	$('.certificate_of_approval_area').slideUp();
	$('.additional_cost_explanation_area').slideToggle();
	$('.relief_system_area').slideUp();
}

/**
 * 「医薬品販売業許認可証／管理・運営者／一般用医薬品の販売制度情報に関する説明エリアを表示」ボタンクリック時処理
 * @param e
 */
function onClickShowCertificateOfApprovalAreaBtn(e) {
	e.preventDefault();

	$('.additional_cost_explanation_area').slideUp();
	$('.certificate_of_approval_area').slideToggle();
	$('.relief_system_area').slideUp();
}


function onClickShowReliefSystemAreaBtn(e) {
	e.preventDefault();

	$('.additional_cost_explanation_area').slideUp();
	$('.certificate_of_approval_area').slideUp();
	$('.relief_system_area').slideToggle();
}

/**
 * 入力値が許容上限値以内かどうかを検証
 * @param e
 */
function validateValueMax(e) {
	const val = $(this).val();
	const max = $(this).attr('max');

	if (parseInt(val) > parseInt(max)) {
		$(this).val(max);
	}
}

/**
 * 翌月の初日の日付をYYYYMMDDフォーマットで取得
 * @returns {string}
 */
function getNextMonthFirstDay() {
	const today = new Date();
	const year = today.getFullYear();
	const month = today.getMonth() + 1; // 翌月 (0-indexed)

	const nextMonth = month === 12 ? 1 : month + 1;
	const nextYear = month === 12 ? year + 1 : year;

	return `${nextYear}${String(nextMonth).padStart(2, '0')}01`;
}

/**
 * 翌月の最終日の日付をYYYYMMDDフォーマットで取得
 * @returns {string}
 */
function getNextMonthLastDay() {
	const today = new Date();
	const year = today.getFullYear();
	const month = today.getMonth() + 1; // 翌月を取得するため +1

	// 翌月の1日を取得し、0日を指定すると「前日」、つまり翌月の最終日になる
	const nextMonth = month === 12 ? 1 : month + 1;
	const nextYear = month === 12 ? year + 1 : year;

	const lastDay = new Date(nextYear, nextMonth, 0).getDate(); // 0を指定すると前月の最終日になる

	return `${nextYear}${String(nextMonth).padStart(2, '0')}${String(lastDay).padStart(2, '0')}`;
}


/**
 * 数量の入力値が受付可能な値かどうか検証
 * @returns {boolean}
 */
function checkQuantity() {

	$('.fake_btn_box').find('.fake_error_msg').empty();

	// チェック用の比較要素が無い場合はチェック処理自体不要なので処理終了
	if ($('#inputStk').length === 0) {
		return false;
	}

	// 年齢制限確認ボタンの表示中も不要な処理として処理終了
	if ($('.age_confirmation_btn_box').length > 0) {
		return false;
	}

	const val = $('input[name="quantity"]').val();
	const stk = $('#inputStk').val();

	if (parseInt(val) > parseInt(stk)) {
		$('.buy_btn_box').hide();
		$('.fake_btn_box').show();
	} else {
		$('.buy_btn_box').show();
		$('.fake_btn_box').hide();
	}
}